// extracted by mini-css-extract-plugin
export default {"page":"_1-z","cartModal":"a2-z","checkout":"b2-z","placeholder":"c2-z","account":"d2-z"};